import { z } from 'zod';

import { getWindow } from '@r-client/shared/util/core';

export enum E_REGION {
  US = 'us',
  EUROPE = 'europe',
}

export const Region = z.nativeEnum(E_REGION);

export enum E_JURISDICTION {
  EU = 'EU',
  GB = 'GB',
}

export const regionJurisdictionDetails = (
  regionJurisdiction: E_REGION | E_JURISDICTION
) => {
  const region =
    regionJurisdiction === E_REGION.US ? E_REGION.US : E_REGION.EUROPE;
  const jurisdiction =
    regionJurisdiction === E_JURISDICTION.EU ||
    regionJurisdiction === E_JURISDICTION.GB
      ? regionJurisdiction
      : undefined;

  return { region, jurisdiction };
};

export const isEuropeURL = (
  url?: string | string[] | null,
  europeOrigin?: string
) => {
  const windowOrigin = getWindow()?.location.origin;
  if (!url || !windowOrigin || !europeOrigin) return false;

  const thisUrl = new URL(Array.isArray(url) ? url[0] : url, windowOrigin);
  const europeOriginUrl = new URL(europeOrigin);

  return thisUrl.hostname === europeOriginUrl.hostname;
};
